const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:8000";

export function authFetch(url, options = {}) {
  const token = localStorage.getItem("token");
  return fetch(`${API_BASE}${url}`, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: token ? `Bearer ${token}` : "",
      "Content-Type": "application/json",
    },
  }).then(async (res) => {
    if (res.status === 401) {
      // token invalid/expired → redirect to login
      window.location.href = "/login";
      return Promise.reject("Unauthorized");
    }
    return res.json();
  });
}

export async function fetchListings(page = 1, limit = 20) {
  const data = await authFetch(`/listings/sale?limit=${limit}&page=${page}`);
  return data;
}

export async function fetchListingsWithPredictions(filters = {}) {
  const params = new URLSearchParams();

  if (filters.search) params.append('search', filters.search);
  if (filters.date_from) params.append('date_from', filters.date_from);
  if (filters.date_to) params.append('date_to', filters.date_to);
  if (filters.beds_min) params.append('beds_min', filters.beds_min);
  if (filters.beds_max) params.append('beds_max', filters.beds_max);
  if (filters.baths_min) params.append('baths_min', filters.baths_min);
  if (filters.baths_max) params.append('baths_max', filters.baths_max);
  if (filters.price_min) params.append('price_min', filters.price_min);
  if (filters.price_max) params.append('price_max', filters.price_max);
  if (filters.property_type) params.append('property_type', filters.property_type);

  const queryString = params.toString();
  const url = `/listings/sale-with-predictions${queryString ? `?${queryString}` : ''}`;
  const data = await authFetch(url);
  return data;
}

export const fetchPrediction = async (propertyId) => {
  const data = await authFetch(`/predict/sale/${propertyId}`);
  console.log("fetchPrediction",data);
  return data;
};
